import api from './index';

export const getInviteCodes = () => {
  return api.get('/admin/invite-codes');
};

export const createInviteCode = (data = {}) => {
  return api.post('/admin/invite-codes', data);
};

export const revokeInviteCode = (id) => {
  return api.delete(`/admin/invite-codes/${id}`);
};

export const getCompanies = () => api.get('/admin/companies');
export const getCompany = (id) => api.get(`/admin/companies/${id}`);
export const getCompanyUsers = (id) => api.get(`/admin/companies/${id}/users`);
export const addCompanyUser = (id, data) => api.post(`/admin/companies/${id}/users`, data);
export const updateCompanyUser = (companyId, userId, data) => api.put(`/admin/companies/${companyId}/users/${userId}`, data);
export const deleteCompanyUser = (companyId, userId) => api.delete(`/admin/companies/${companyId}/users/${userId}`);

export const getAuditLog = (params = {}) => {
  return api.get('/admin/audit-log', { params });
};
